import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Box from '../components/Box'
import PropertyLabel from '../components/PropertyLabel'
import AssignedItemList from '../components/AssignedItemList'
import ErrorMessage from '../components/ErrorMessage'

import { fetchPopulatedContract, updateContract } from '../actions/contracts'

class ContractDetailsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      closing: false,
      terminateConfirmShown: false
    }

    this.terminateContract = this.terminateContract.bind(this)
    this.terminateConfirmShow = this.terminateConfirmShow.bind(this)
    this.terminateConfirmToggle = this.terminateConfirmToggle.bind(this)
  }

  componentDidMount() {
    this.props.fetchPopulatedContract(this.props.match.params.number)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.deleting && !nextProps.loading) {
      this.props.push('/contracts')
    }
  }

  terminateContract() {
    const { updateContract, contract } = this.props

    this.setState({ deleting: true })
    updateContract(contract.number, { ...contract, Status: 'TERMINATED' })
  }

  terminateConfirmShow() {
    this.setState({ terminateConfirmShown: true })
  }

  terminateConfirmToggle() {
    this.setState({ terminateConfirmShown: !this.state.terminateConfirmShown })
  }

  render() {
    const { role, contract, error, loading } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message} />
      )
    }

    if (!contract || loading) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    return (
      <div>
        <div className="row mb-2">
          <div className="col col-12 col-xs-12 col-sm-6 col-md-6">
            <h1>
              <span className="text-vw-dark">DETALLES DEL </span>
              <span className="text-vw-light">CONTRATO</span>
            </h1>
          </div>
          {role === 'ADMIN' && contract.Status === 'VALID' &&
            <div className="col col-12 col-xs-12 col-sm-6 col-md-6 text-right">
              <Link to={`/contracts/${contract.number}/edit`}>
                <button className="btn bg-vw-light text-white mr-1">
                  <i className="fas fa-edit mr-1"></i>Editar
                </button>
              </Link>
              <button className="btn btn-warning mr-1" onClick={this.terminateConfirmShow}>
                <i className="fas fa-times-circle mr-1"></i>Terminar
              </button>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <Box title="Resumen" icon="sliders-h">
              <div className="row">
                <div className="col col-12 col-xs-12 col-md-6">
                  <PropertyLabel name="Número"
                    value={contract.number} />
                  <PropertyLabel name="Fecha inicio"
                    value={(new Date(contract.StartDate)).toDateString()} />
                  <PropertyLabel name="Fecha fin"
                    value={(new Date(contract.EndDate)).toDateString()} />
                  <PropertyLabel name="Máquina"
                    value={contract.Machine.Serial} />
                </div>
                <div className="col col-12 col-xs-12 col-md-6">
                  <PropertyLabel name="Localización"
                    value={contract.Location} />
                  <PropertyLabel name="Working Mode"
                    value={contract.WorkingMode == 0 ? "WATERPROOF" : "WATERPROOF + LOCKERS"} />
                  <PropertyLabel name="Report AE Italia"
                    value={contract.ReportAE} />
                  <PropertyLabel name="Moneda"
                    value={contract.Currency} />
                  <PropertyLabel name="Tasa de conversión"
                    value={contract.ConversionRate} />
                </div>
              </div>
            </Box>
            <Box title="Ticket" icon="receipt">
              <PropertyLabel name="Cabecera" ml
                value={contract.TicketHeader} />
              <PropertyLabel name="IVA" ml
                value={contract.TicketIVA} />
              <PropertyLabel name="Footer" ml
                value={contract.TicketFooter} />
            </Box>
            <Box title="Artículos" icon="shopping-cart">
              <AssignedItemList items={contract.Items} currency={contract.Currency} conversionrate={contract.ConversionRate} />
            </Box>
          </div>
          <div className="col col-12 col-xs-12 col-md-4">
            <Box title="Contrato" icon="power-off">
              <PropertyLabel name="Estado" ml
                value={contract.Status} />
              <PropertyLabel name="Última edición" ml
                value={contract.Executor} />
            </Box>
            <Box title="Cliente" icon="user">
              <PropertyLabel name="Nombre" ml
                value={contract.Customer.Fullname} />
              {contract.Customer.sector &&
                <PropertyLabel name="Sector" ml
                  value={contract.Customer.Sector.description} />}
            </Box>
          </div>
        </div>
        {/* Confirm terminate */}
        <div>
          <Modal isOpen={this.state.terminateConfirmShown}
            toggle={this.terminateConfirmToggle}>
            <ModalHeader toggle={this.terminateConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de terminar el contrato?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.terminateContract}>
                Terminar
              </Button>
              <Button color="secondary" onClick={this.terminateConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}



const mapStateToProps = state => ({
  contract: state.contracts.populatedContract,
  loading: state.contracts.loading,
  error: state.contracts.error,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchPopulatedContract: bindActionCreators(fetchPopulatedContract, dispatch),
  updateContract: bindActionCreators(updateContract, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ContractDetailsView)


